import "@/styles/GoldenRod.scss";

interface GoldenRodProps {
    bodyText?: string | React.ReactNode;
    headline?: React.ReactNode;
}
/**
 * Display a blast message
 * @name GoldenRod
 */
const GoldenRod = ({ bodyText, headline }: GoldenRodProps): React.JSX.Element => {
    return (
        <div className="golden-rod">
            {headline && <div className="headline">{headline}</div>}
            {bodyText && <div className="body">{bodyText}</div>}
        </div>
    );
};

export default GoldenRod;
